import { Component, Input, OnInit, ElementRef, ViewChild } from '@angular/core';
import { UxService } from '~/app/core/services';
import { AppointmentsService } from '~/app/open-age/welcome/services';
import { RoleService } from '~/app/open-age/core/services';
import { User } from '~/app/open-age/welcome/models/user.model';
import * as moment from 'moment-timezone';
import { MatAccordion } from '@angular/material';

@Component({
  selector: 'welcome-appointment-logs',
  templateUrl: './appointment-logs.component.html',
  styleUrls: ['./appointment-logs.component.css']
})
export class AppointmentLogsComponent {

  @Input()
  id: String;

  @Input()
  name: String;

  @Input()
  isPatientMatch: String;

  isProcessing = false

  @Input()
  timeZone: string;

  logs: {
    duration: Number,
    userDetails: any,
    user?: User,
    userIds: {
      userId: String,
      firstStart: Date,
      lastStart: Date,
      lastEnd: Date,
      duration: Number
    }[]
  }[] = []

  constructor(
    private service: AppointmentsService,
    uxService: UxService,
    private auth: RoleService
  ) {
  }

  ngOnChanges() {
    if (this.id) {
      this.isProcessing = true
      let params = ""
      if (this.isPatientMatch) {
        if (params) {
          params = params + `&isMatch=${this.isPatientMatch}`
        } else {
          params = `?isMatch=${this.isPatientMatch}`
        }
      }
      if (this.name) {
        if (params) {
          params = params + `&name=${this.name}`
        } else {
          params = `?name=${this.name}`
        }
      }
      this.service.get(`logs/${this.id}${params}`).subscribe(item => {
        this.logs = item.logs
        this.isProcessing = false
      }, err => {
        this.isProcessing = false
      })
    }
  }

  getTime(date: Date) {
    if (date && moment(date).isValid) {
      if (this.timeZone) {
        return moment(date).tz(this.timeZone).format("h:mm a")
      } else {
        return moment(date).format("h:mm a")
      }
    } else {
      return ''
    }
  }

  getDate(date: Date) {
    if (date && moment(date).isValid) {
      if (this.timeZone) {
        return moment(date).tz(this.timeZone).format("MM/DD/YYYY")
      } else {
        return moment(date).format("MM/DD/YYYY")
      }
    } else {
      return ''
    }
  }

  getDateTime(date: Date) {
    if (date && moment(date).isValid) {
      if (this.timeZone) {
        return moment(date).tz(this.timeZone).format("MM/DD/YYYY h:mm a")
      } else {
        return moment(date).format("MM/DD/YYYY h:mm a")
      }
    } else {
      return ''
    }
  }

}
